<!-- Navbar -->
<app-navbar></app-navbar>

<!-- Rutas -->
<router-outlet></router-outlet>

<!-- Footer -->
<app-footer></app-footer>